<template>
  <div id="centerRight" class="content-box-item">
    <el-image class="box-item-bg" :src="require('@/assets/images/bg-3.png')" fit="sfit"/>
    <div class="center-left">

      <span class="text-1">客户：{{cdata.tagClientCount}} 人</span>
      <span class="text-2">意向：{{cdata.tagClientOKCount}} 人</span>
      <span class="text-2">未明：{{cdata.tagClientUnKnowCount}} 人</span>
      <span class="text-1">待开发：{{cdata.tagClientWaitCount}} 人</span>
      <div class="button-con">目标客户</div>
    </div>
    <div class="center-right">
      <el-image class="big-icon" :src="require('@/assets/icons/big-icon-3.png')" fit="fit"/>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  //
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    cdata: {
      handler (newData) {

      },
      immediate: true,
      deep: true
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
#centerRight {
  width: calc(100% - 15px);
  margin-left: 15px;
  .box-item-bg{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 0;
  }
  .center-left{
    width: 52%;
    height: 90%;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    padding-left: 30px;
    z-index: 1;
  }
  .center-right{
    width: 48%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
  }
  .text-1{
    font-size: 18px;
    line-height: 35px;
    text-align: center;
    background-image:-webkit-linear-gradient(left,#917afc, #c4b9fd);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
  }
  .text-2{
    font-size: 18px;
    line-height: 35px;
    text-align: center;
    color: #707070;
  }
  .button-con{
    width: 154px;
    height: 60px;
    font-size: 22px;
    line-height: 60px;
    text-align: center;
    margin-top: 30px;
    border-radius: 10px;
    color: #FFFFFF;
    background: linear-gradient(120.93deg, #917afc 3.98%, #c4b9fd 100%);
    /* 卡片阴影 */
    box-shadow: 0px 0px 8px 2px rgba(238, 56, 35, 0.09);
  }
  .big-icon{
    margin-top: 45px;
    margin-left: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/data/center/centerRight.vue